export const getSelectedReportType = (reportType) => {
    return  {
        type: "SELECTED_REPORTTYPE",
        payload: reportType
    };
};

export const getSelectedGraphType = (graphType) => {
    return  {
        type: "SELECTED_GRAPHTYPE",
        payload: graphType
    };
};


export const getSelectedShiftType = (shiftType) => {
    return  {
        type: "SELECTED_SHIFTTYPE",
        payload: shiftType
    };
};

export const getSelectedShiftTypeGraph = (shiftTypeGraph) => {
    return  {
        type: "SELECTED_SHIFTTYPE_GRAPH",
        payload: shiftTypeGraph
    };
};